// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DownloadNotificationEventEmitter = Symbol('DownloadNotificationEventEmitter');
